// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falMinus: CreateIconOptions = {
  "displayName": "FALMinus",
  "viewBox": "0, 0, 448, 512",
  "d": "M432 256c0 8.8-7.2 16-16 16L32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l384 0c8.8 0 16 7.2 16 16z"
};
